import { lazy } from "react";

const WeddingHallHome = lazy(() => import("../pages/weddingHall/WeddingHallHome"));
const WeddingHallSearch = lazy(() => import("../pages/weddingHall/WeddingHallSearch"));
const WeddingHallSlot = lazy(() => import("../pages/weddingHall/WeddingHallSlot"));
const WeddingHallEvent = lazy(() => import("../pages/weddingHall/WeddingHallEvent"));
const WeddingHallEventDetail = lazy(() => import("../pages/weddingHall/event/EventDetail"));
const HallSearchFilter = lazy(() => import("../pages/weddingHall/HallSearchFilter"));
const HallSearchResult = lazy(() => import("../pages/weddingHall/HallSearchResult"));
const HallCompare = lazy(() => import("@src/pages/weddingHall/compare/HallCompareSelect"));
const HallCompareResult = lazy(()=> import("@src/pages/weddingHall/compare/HallCompareResult"));
const VisitBookingIntro = lazy(()=> import("@src/pages/weddingHall/compare/VisitBookingIntro"));

const HallDetailPreview = lazy(() => import("../pages/weddingHall/preview/HallDetailPreview"));
const HallPreview = lazy(() => import("../pages/weddingHall/preview/HallPreview"));

export const weddingHallRoutes = [
  { path: "/weddinghall/event", element: <WeddingHallEvent /> },
  { path: "/weddinghall/event/:eventId", element: <WeddingHallEventDetail /> },
  { path: "/weddinghall/home", element: <WeddingHallHome /> },
  { path: "/weddinghall/search", element: <WeddingHallSearch /> },
  { path: "/weddinghall/search-filter", element: <HallSearchFilter /> },
  // { path: "/slot/search-filter", element: <HallSearchFilter /> }, //잔여타임 검색 사용 안함
  { path: "/weddinghall/slot", element: <WeddingHallSlot /> },
  { path: "/weddinghall/result/slot", element: <HallSearchResult /> },
  { path: "/weddinghall/result/hall", element: <HallSearchResult /> },
  
  { path: "/weddinghall/compare/select", element: <HallCompare /> }, // 웨딩홀 비교하기 선택
  { path: "/weddinghall/compare/result", element: <HallCompareResult /> }, // 웨딩홀 비교하기 결과
  { path: "/weddinghall/compare/booking-intro", element: <VisitBookingIntro /> }, // 웨딩홀 비교하기 -> 방문예약 인트로

  // 웨딩홀 어드민 미리보기 페이지
  { path: "/weddinghall/:partnerProfileId/preview", element: <HallPreview /> },
  { path: "/weddinghall/:partnerProfileId/detail-preview/:individualHallId", element: <HallDetailPreview /> },
];